"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchObject = exports.fetchAllObjects = void 0;
var index_1 = require("../fetch-all-pages/index");
var CACHE = {};
function generateCacheKey(url, params, body) {
    return "".concat(url, " ").concat(JSON.stringify(params), " ").concat(JSON.stringify(body));
}
function fetchAllObjects(client, url, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var opts, cacheKey, responseData;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    opts = __assign({ cache: true, cacheExpiryTimeMs: 15000, params: {}, body: {} }, options);
                    cacheKey = generateCacheKey(url, opts.params, opts.body);
                    if (!(opts.cache && CACHE[cacheKey])) return [3 /*break*/, 1];
                    // Use cached value
                    responseData = CACHE[cacheKey];
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, (0, index_1.fetchAllPages)(function (page) { return __awaiter(_this, void 0, void 0, function () {
                        var response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, client.get(url, {
                                        params: __assign(__assign({}, opts.params), { page: page, page_size: opts.pageSize || 5000 }),
                                    })];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, response.data];
                            }
                        });
                    }); }, opts.pageTest)];
                case 2:
                    // Value not cached, make request and add to cache if cache should be used
                    responseData = _a.sent();
                    if (opts.cache) {
                        CACHE[cacheKey] = responseData;
                        // After the specified amount of time, remove this entry from the cache
                        setTimeout(function () {
                            delete CACHE[cacheKey];
                        }, opts.cacheExpiryTimeMs);
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/, responseData];
            }
        });
    });
}
exports.fetchAllObjects = fetchAllObjects;
function fetchObject(client, url, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var opts, cacheKey, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    opts = __assign({ cache: true, cacheExpiryTimeMs: 15000, params: {}, body: {} }, options);
                    cacheKey = generateCacheKey(url, opts.params, opts.body);
                    if (!(opts.cache && CACHE[cacheKey])) return [3 /*break*/, 1];
                    // Use cached value
                    response = CACHE[cacheKey];
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, client.get(url, { params: opts.params })];
                case 2:
                    // Value not cached, make request and add to cache if cache should be used
                    response = _a.sent();
                    if (opts.cache) {
                        CACHE[cacheKey] = response;
                        // After the specified amount of time, remove this entry from the cache
                        setTimeout(function () {
                            delete CACHE[cacheKey];
                        }, opts.cacheExpiryTimeMs);
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/, response.data];
            }
        });
    });
}
exports.fetchObject = fetchObject;
//# sourceMappingURL=index.js.map